import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'linkUrl'
})
export class LinkUrlPipe implements PipeTransform {

  status: any;
  constructor(private sanitizer: DomSanitizer){}
  transform(texto: string, ...args: unknown[]): unknown {
    let nuevoTexto: string = '';
    if (texto.includes('http') || texto.includes('www')) {
        const splitedText = texto.split(' ');
        splitedText.forEach(element => {
            if (element.includes('http') || element.includes('www')) {
                nuevoTexto += `<a href="${element}">${element}</a> `
            }else{
                nuevoTexto += element + ' '
            }
        });
    }else{
        nuevoTexto = texto;
    }
    return this.sanitizer.bypassSecurityTrustHtml(nuevoTexto);
  }

}
